import axios from "@/plugins/axios";

let url = "/api/console/pins";

export default {
    get(data){
        return axios.get(url, data).then(result => result.data);
    },
}
